
import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Breadcrumb from '../../components/feature/Breadcrumb';
import Button from '../../components/base/Button';

export default function Search() {
  const [searchFilters, setSearchFilters] = useState({
    area: '',
    propertyType: '',
    priceMin: '',
    priceMax: '',
    layout: '',
    walkingDistance: ''
  });

  const areas = [
    { value: 'shibuya', label: '渋谷区' },
    { value: 'shinjuku', label: '新宿区' },
    { value: 'minato', label: '港区' },
    { value: 'setagaya', label: '世田谷区' },
    { value: 'meguro', label: '目黒区' },
    { value: 'ota', label: '大田区' },
    { value: 'suginami', label: '杉並区' },
    { value: 'nerima', label: '練馬区' }
  ];

  const propertyTypes = [
    { value: 'new-house', label: '新築戸建' },
    { value: 'used-house', label: '中古戸建' },
    { value: 'mansion', label: 'マンション' },
    { value: 'land', label: '土地' }
  ];

  const priceRanges = [
    { value: '0', label: '下限なし' },
    { value: '2000', label: '2,000万円' },
    { value: '3000', label: '3,000万円' },
    { value: '4000', label: '4,000万円' },
    { value: '5000', label: '5,000万円' },
    { value: '6000', label: '6,000万円' },
    { value: '8000', label: '8,000万円' },
    { value: '10000', label: '1億円' }
  ];

  const layouts = [
    { value: '1LDK', label: '1LDK' },
    { value: '2LDK', label: '2LDK' },
    { value: '3LDK', label: '3LDK' },
    { value: '4LDK', label: '4LDK' },
    { value: '4LDK+', label: '4LDK以上' }
  ];

  const walkingDistances = [
    { value: '5', label: '5分以内' },
    { value: '10', label: '10分以内' },
    { value: '15', label: '15分以内' },
    { value: 'none', label: '指定なし' }
  ];

  const properties = [
    {
      id: 1,
      image: 'https://public.readdy.ai/ai/img_res/a0958af66fa0c2bd2c200e6fecb7377d.jpg',
      price: '3,480万円',
      location: '東京都世田谷区成城4丁目',
      transport: '小田急線 成城学園前駅 徒歩8分',
      layout: '3LDK',
      area: '78.25㎡',
      age: '築5年',
      isFavorite: false
    },
    {
      id: 2,
      image: 'https://readdy.ai/api/search-image?query=Modern%20apartment%20building%20exterior%20with%20glass%20facade%2C%20contemporary%20design%2C%20urban%20setting%2C%20professional%20real%20estate%20photography%2C%20clean%20architecture%2C%20residential%20complex%2C%20bright%20daylight&width=400&height=225&seq=search2&orientation=landscape',
      price: '5,280万円',
      location: '東京都渋谷区恵比寿2丁目',
      transport: 'JR山手線 恵比寿駅 徒歩6分',
      layout: '2LDK',
      area: '65.40㎡',
      age: '築3年',
      isFavorite: false
    },
    {
      id: 3,
      image: 'https://readdy.ai/api/search-image?query=Luxury%20residential%20building%20with%20modern%20architecture%2C%20elegant%20entrance%2C%20professional%20real%20estate%20photography%2C%20high-end%20apartment%20complex%2C%20contemporary%20design%2C%20urban%20location&width=400&height=225&seq=search3&orientation=landscape',
      price: '6,800万円',
      location: '東京都港区白金台3丁目',
      transport: '東京メトロ南北線 白金台駅 徒歩4分',
      layout: '3LDK',
      area: '85.60㎡',
      age: '築2年',
      isFavorite: false
    },
    {
      id: 4,
      image: 'https://readdy.ai/api/search-image?query=Traditional%20Japanese%20house%20with%20modern%20renovation%2C%20wooden%20exterior%2C%20contemporary%20design%20elements%2C%20residential%20area%2C%20professional%20real%20estate%20photography%2C%20natural%20lighting&width=400&height=225&seq=search4&orientation=landscape',
      price: '4,200万円',
      location: '東京都杉並区荻窪1丁目',
      transport: 'JR中央線 荻窪駅 徒歩12分',
      layout: '4LDK',
      area: '95.30㎡',
      age: '築8年',
      isFavorite: false
    },
    {
      id: 5,
      image: 'https://readdy.ai/api/search-image?query=Modern%20condominium%20building%20exterior%20with%20contemporary%20architecture%2C%20glass%20windows%2C%20professional%20real%20estate%20photography%2C%20residential%20complex%2C%20urban%20setting%2C%20clean%20design&width=400&height=225&seq=search5&orientation=landscape',
      price: '7,500万円',
      location: '東京都新宿区西新宿5丁目',
      transport: '都営大江戸線 都庁前駅 徒歩7分',
      layout: '3LDK',
      area: '72.80㎡',
      age: '築1年',
      isFavorite: false
    },
    {
      id: 6,
      image: 'https://readdy.ai/api/search-image?query=Beautiful%20family%20house%20with%20garden%2C%20modern%20Japanese%20architecture%2C%20residential%20neighborhood%2C%20professional%20real%20estate%20photography%2C%20natural%20lighting%2C%20contemporary%20design&width=400&height=225&seq=search6&orientation=landscape',
      price: '5,980万円',
      location: '東京都目黒区自由が丘2丁目',
      transport: '東急東横線 自由が丘駅 徒歩9分',
      layout: '4LDK',
      area: '110.50㎡',
      age: '築6年',
      isFavorite: false
    },
    {
      id: 7,
      image: 'https://readdy.ai/api/search-image?query=Elegant%20modern%20apartment%20building%20with%20sophisticated%20architecture%2C%20premium%20residential%20complex%2C%20professional%20real%20estate%20photography%2C%20urban%20luxury%20setting%2C%20contemporary%20facade%20design&width=400&height=225&seq=search7&orientation=landscape',
      price: '4,680万円',
      location: '東京都品川区大崎3丁目',
      transport: 'JR山手線 大崎駅 徒歩5分',
      layout: '2LDK',
      area: '68.90㎡',
      age: '築4年',
      isFavorite: false
    },
    {
      id: 8,
      image: 'https://readdy.ai/api/search-image?query=Modern%20townhouse%20with%20contemporary%20design%2C%20residential%20area%2C%20professional%20real%20estate%20photography%2C%20clean%20architecture%2C%20family-friendly%20neighborhood%2C%20bright%20natural%20lighting&width=400&height=225&seq=search8&orientation=landscape',
      price: '6,200万円',
      location: '東京都中野区中野5丁目',
      transport: 'JR中央線 中野駅 徒歩7分',
      layout: '3LDK',
      area: '88.40㎡',
      age: '築3年',
      isFavorite: false
    },
    {
      id: 9,
      image: 'https://readdy.ai/api/search-image?query=Luxury%20high-rise%20apartment%20building%20with%20modern%20glass%20facade%2C%20premium%20residential%20tower%2C%20professional%20real%20estate%20photography%2C%20urban%20skyline%20view%2C%20contemporary%20architecture&width=400&height=225&seq=search9&orientation=landscape',
      price: '8,800万円',
      location: '東京都港区赤坂2丁目',
      transport: '東京メトロ銀座線 赤坂見附駅 徒歩3分',
      layout: '3LDK',
      area: '92.15㎡',
      age: '築1年',
      isFavorite: false
    },
    {
      id: 10,
      image: 'https://readdy.ai/api/search-image?query=Charming%20residential%20house%20with%20modern%20renovation%2C%20suburban%20setting%2C%20professional%20real%20estate%20photography%2C%20family%20home%20with%20garden%2C%20contemporary%20exterior%20design&width=400&height=225&seq=search10&orientation=landscape',
      price: '3,980万円',
      location: '東京都練馬区石神井町4丁目',
      transport: '西武池袋線 石神井公園駅 徒歩10分',
      layout: '4LDK',
      area: '105.80㎡',
      age: '築7年',
      isFavorite: false
    },
    {
      id: 11,
      image: 'https://readdy.ai/api/search-image?query=Modern%20apartment%20complex%20with%20sleek%20design%2C%20professional%20real%20estate%20photography%2C%20residential%20building%20with%20balconies%2C%20contemporary%20urban%20architecture%2C%20clean%20lines&width=400&height=225&seq=search11&orientation=landscape',
      price: '5,500万円',
      location: '東京都豊島区池袋3丁目',
      transport: 'JR山手線 池袋駅 徒歩8分',
      layout: '2LDK',
      area: '70.25㎡',
      age: '築2年',
      isFavorite: false
    },
    {
      id: 12,
      image: 'https://readdy.ai/api/search-image?query=Beautiful%20detached%20house%20with%20contemporary%20design%2C%20residential%20neighborhood%2C%20professional%20real%20estate%20photography%2C%20modern%20family%20home%2C%20elegant%20exterior%20with%20garden%20space&width=400&height=225&seq=search12&orientation=landscape',
      price: '7,200万円',
      location: '東京都文京区本郷2丁目',
      transport: '東京メトロ丸ノ内線 本郷三丁目駅 徒歩6分',
      layout: '4LDK',
      area: '115.60㎡',
      age: '築4年',
      isFavorite: false
    }
  ];

  const [favoriteProperties, setFavoriteProperties] = useState<number[]>([]);
  const [currentPage, setCurrentPage] = useState(1);

  const toggleFavorite = (propertyId: number) => {
    setFavoriteProperties(prev => 
      prev.includes(propertyId) 
        ? prev.filter(id => id !== propertyId)
        : [...prev, propertyId]
    );
  };

  const handleFilterChange = (key: string, value: string) => {
    setSearchFilters(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <Breadcrumb />
      
      {/* Hero Section */}
      <section className="bg-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            物件検索
          </h1>
          <p className="text-xl text-gray-600 mb-8">
            エリアや条件から、あなたにぴったりの住まいを見つけましょう。
          </p>
        </div>
      </section>

      {/* Search Filters */}
      <section className="py-8 bg-white border-t">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-gray-50 rounded-2xl p-8">
            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-6">
              {/* Area */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  エリア
                </label>
                <div className="relative">
                  <select
                    value={searchFilters.area}
                    onChange={(e) => handleFilterChange('area', e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none bg-white pr-8 cursor-pointer text-sm"
                  >
                    <option value="">選択してください</option>
                    {areas.map((area) => (
                      <option key={area.value} value={area.value}>
                        {area.label}
                      </option>
                    ))}
                  </select>
                  <i className="ri-arrow-down-s-line absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"></i>
                </div>
              </div>

              {/* Property Type */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  種別
                </label>
                <div className="relative">
                  <select
                    value={searchFilters.propertyType}
                    onChange={(e) => handleFilterChange('propertyType', e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none bg-white pr-8 cursor-pointer text-sm"
                  >
                    <option value="">選択してください</option>
                    {propertyTypes.map((type) => (
                      <option key={type.value} value={type.value}>
                        {type.label}
                      </option>
                    ))}
                  </select>
                  <i className="ri-arrow-down-s-line absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"></i>
                </div>
              </div>

              {/* Price Min */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  価格下限
                </label>
                <div className="relative">
                  <select
                    value={searchFilters.priceMin}
                    onChange={(e) => handleFilterChange('priceMin', e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none bg-white pr-8 cursor-pointer text-sm"
                  >
                    <option value="">下限なし</option>
                    {priceRanges.map((price) => (
                      <option key={price.value} value={price.value}>
                        {price.label}
                      </option>
                    ))}
                  </select>
                  <i className="ri-arrow-down-s-line absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"></i>
                </div>
              </div>

              {/* Price Max */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  価格上限
                </label>
                <div className="relative">
                  <select
                    value={searchFilters.priceMax}
                    onChange={(e) => handleFilterChange('priceMax', e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none bg-white pr-8 cursor-pointer text-sm"
                  >
                    <option value="">上限なし</option>
                    {priceRanges.map((price) => (
                      <option key={price.value} value={price.value}>
                        {price.label}
                      </option>
                    ))}
                  </select>
                  <i className="ri-arrow-down-s-line absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"></i>
                </div>
              </div>

              {/* Layout */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  間取り
                </label>
                <div className="relative">
                  <select
                    value={searchFilters.layout}
                    onChange={(e) => handleFilterChange('layout', e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none bg-white pr-8 cursor-pointer text-sm"
                  >
                    <option value="">選択してください</option>
                    {layouts.map((layout) => (
                      <option key={layout.value} value={layout.value}>
                        {layout.label}
                      </option>
                    ))}
                  </select>
                  <i className="ri-arrow-down-s-line absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"></i>
                </div>
              </div>

              {/* Walking Distance */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  駅徒歩
                </label>
                <div className="relative">
                  <select
                    value={searchFilters.walkingDistance}
                    onChange={(e) => handleFilterChange('walkingDistance', e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none bg-white pr-8 cursor-pointer text-sm"
                  >
                    <option value="">選択してください</option>
                    {walkingDistances.map((distance) => (
                      <option key={distance.value} value={distance.value}>
                        {distance.label}
                      </option>
                    ))}
                  </select>
                  <i className="ri-arrow-down-s-line absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"></i>
                </div>
              </div>
            </div>

            <div className="flex justify-end">
              <Button className="bg-blue-600 hover:bg-blue-700">
                <i className="ri-search-line mr-2"></i>
                この条件で検索する
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Search Results */}
      <section className="py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12" data-product-shop>
            {properties.map((property) => (
              <div key={property.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl hover:scale-105 transition-all duration-300 cursor-pointer">
                <div className="relative">
                  <img
                    src={property.image}
                    alt={property.location}
                    className="w-full h-56 object-cover object-top"
                  />
                  <button
                    onClick={() => toggleFavorite(property.id)}
                    className={`absolute top-4 right-4 w-10 h-10 rounded-full flex items-center justify-center transition-colors cursor-pointer ${
                      favoriteProperties.includes(property.id)
                        ? 'bg-red-500 text-white'
                        : 'bg-white/80 text-gray-600 hover:bg-white'
                    }`}
                  >
                    <i className={`ri-heart-${favoriteProperties.includes(property.id) ? 'fill' : 'line'}`}></i>
                  </button>
                </div>
                
                <div className="p-6">
                  <div className="text-2xl font-bold text-blue-600 mb-3">
                    {property.price}
                  </div>
                  
                  <div className="space-y-2 mb-4">
                    <div className="flex items-start text-gray-700">
                      <i className="ri-map-pin-line mr-2 mt-1 text-gray-500"></i>
                      <span className="text-sm font-medium">{property.location}</span>
                    </div>
                    
                    <div className="flex items-center text-gray-600">
                      <i className="ri-train-line mr-2 text-gray-500"></i>
                      <span className="text-sm">{property.transport}</span>
                    </div>
                    
                    <div className="flex items-center text-gray-600">
                      <i className="ri-home-line mr-2 text-gray-500"></i>
                      <span className="text-sm">{property.layout} / {property.area}</span>
                    </div>
                    
                    <div className="flex items-center text-gray-600">
                      <i className="ri-calendar-line mr-2 text-gray-500"></i>
                      <span className="text-sm">{property.age}</span>
                    </div>
                  </div>
                  
                  <Button className="w-full bg-blue-600 hover:bg-blue-700">
                    詳細を見る
                  </Button>
                </div>
              </div>
            ))}
          </div>

          {/* Pagination */}
          <div className="flex justify-center">
            <div className="flex items-center space-x-2">
              <button 
                onClick={() => handlePageChange(Math.max(1, currentPage - 1))}
                className="px-4 py-2 text-gray-500 hover:text-blue-600 cursor-pointer"
              >
                前へ
              </button>
              <button 
                onClick={() => handlePageChange(1)}
                className={`px-4 py-2 rounded-lg cursor-pointer ${
                  currentPage === 1 
                    ? 'bg-blue-600 text-white' 
                    : 'text-gray-700 hover:text-blue-600'
                }`}
              >
                1
              </button>
              <button 
                onClick={() => handlePageChange(2)}
                className={`px-4 py-2 rounded-lg cursor-pointer ${
                  currentPage === 2 
                    ? 'bg-blue-600 text-white' 
                    : 'text-gray-700 hover:text-blue-600'
                }`}
              >
                2
              </button>
              <button 
                onClick={() => handlePageChange(3)}
                className={`px-4 py-2 rounded-lg cursor-pointer ${
                  currentPage === 3 
                    ? 'bg-blue-600 text-white' 
                    : 'text-gray-700 hover:text-blue-600'
                }`}
              >
                3
              </button>
              <button 
                onClick={() => handlePageChange(Math.min(3, currentPage + 1))}
                className="px-4 py-2 text-gray-700 hover:text-blue-600 cursor-pointer"
              >
                次へ
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            ご希望の条件が見つからない方へ
          </h2>
          <p className="text-lg text-gray-600 mb-8">
            ご希望条件をお知らせいただければ、担当スタッフが最適な物件をご紹介いたします。
          </p>
          <div className="flex justify-center">
            <Button size="lg" className="bg-blue-600 hover:bg-blue-700">
              <i className="ri-mail-line mr-2"></i>
              無料相談フォームへ
            </Button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
